// Audit tafsilotining ODAM O'QIYDIGAN shakli — BUG-044.
//
// ⚠️ NEGA ALOHIDA FAYL: bu funksiya SOF (import'siz, brauzer API'siz)
// va uni qorovul (`tests/tester2-system-notify.mjs`) TO'G'RIDAN-TO'G'RI
// import qilib, bazadan o'lchangan haqiqiy shakllar bilan sinaydi.
// `auditApi.ts` ichida qolsa bu mumkin emasdi: u `zod`, `axios` va `@/`
// taxallusini tortadi, node esa ularni yecha olmaydi va tekshiruv
// "modulni yuklab bo'lmadi" bilan yiqilardi (o'lchandi 2026-08-16).

/**
 * Jurnal tafsilotining BITTA qatori — «maydon: bo'lgan → bo'ldi».
 *
 * `before === null` bo'lsa bu o'zgarish emas, shunchaki fakt
 * (`login: firdavs15`).
 */
export interface AuditDetailField {
  /** Xom kalit — yorliq `audit.field.<key>` dan olinadi, bo'lmasa kalitning o'zi */
  key: string
  /** Oldingi qiymat; `null` — o'zgarish emas */
  before: string | null
  value: string
  /**
   * Ichma-ich tuzilma (obyekt yoki obyektlar massivi) — bu qatorda faqat
   * SONI ko'rinadi, to'lig'i texnik blokda. Ular UI'da "texnik
   * ma'lumotga qarang" izohini oladi.
   */
  nested: boolean
}

/** Massivdagi elementlar ro'yxati — juda uzun bo'lsa kesiladi */
const LIST_MAX = 160

function isPlainObject(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v)
}

/** `[a, b]` — Java `Collection.toString()` bergan SATR (JSON massivi EMAS) */
const JAVA_LIST = /^\[([^[\]{}]*)]$/
/** `{K=1, R=2}` — Java `Map.toString()` bergan SATR */
const JAVA_MAP = /^\{([^[\]{}]*)}$/
const JAVA_MAP_ENTRY = /^([^=]+)=(.*)$/

/**
 * Qavs ichidagi Java `toString()` matnini qavssiz ro'yxatga aylantiradi.
 *
 * <h2>⚠️ NEGA KERAK — BAZADAN O'LCHANGAN, TAXMIN EMAS</h2>
 * `platform.audit_log` da (20 445 qator, 2026-08-16) to'rtta kalitning
 * qiymati JSON tuzilmasi EMAS, Java'ning `toString()` matni bo'lib
 * SATR sifatida yozilgan — ya'ni ular `toDetailFields` ning obyekt/massiv
 * shoxlariga UMUMAN tushmaydi va ekranga qavslari bilan chiqardi:
 *
 * <pre>
 *   limits          {DELETE=1, RENAME=1, PROFILE_CHANGE=1, MAC_CHANGE=1}   30 qator
 *   allowedMethods  [SMS_OTP]                                              61 qator
 *   methodsFrom/To  [SMS_OTP, PASSWORD]                                    86 qator
 *   ipAllowlist     [10.10.10.12, 172.18.0.1] → [...]                      (o'zgarish)
 * </pre>
 *
 * Aynan shu — testerning «AUDIT LOGDA JSON BO'LMASLIGI KK» nuqsonining
 * qolgan qismi. Yozuvni QAYTA YOZIB bo'lmaydi (`audit_log_no_update`
 * cheklovi) va bu satrlarni yozadigan servislar boshqa doirada, shuning
 * uchun tuzatish O'QISH tomonida.
 *
 * <h2>⚠️ ICHMA-ICH SHAKL TEGILMAYDI</h2>
 * Naqshlar ichkarida yana qavs bo'lmasligini talab qiladi va xarita uchun
 * HAR bo'lak `kalit=qiymat` bo'lishi shart. Ya'ni `{"a":1}` (haqiqiy JSON
 * matni) yoki `[{...}]` bu yerdan O'ZGARMASDAN o'tadi — ularni yarim
 * ochish xom JSON'ni "chiroyliroq xom JSON" ga aylantirardi, xolos.
 */
function unwrapJavaToString(text: string): string {
  const list = JAVA_LIST.exec(text)
  if (list) return (list[1] ?? '').trim()

  const map = JAVA_MAP.exec(text)
  if (!map) return text

  const body = (map[1] ?? '').trim()
  if (body === '') return ''

  const pairs: string[] = []
  for (const part of body.split(', ')) {
    const entry = JAVA_MAP_ENTRY.exec(part)
    // Bitta bo'lak ham `kalit=qiymat` bo'lmasa — bu Java xaritasi EMAS,
    // qiymat O'ZGARMASDAN qoladi
    if (!entry) return text
    pairs.push(`${(entry[1] ?? '').trim()}: ${(entry[2] ?? '').trim()}`)
  }
  return pairs.join(', ')
}

/**
 * Skalyar qiymatning matni.
 *
 * ⚠️ `String(v)` ISHLATILMAYDI: `unknown` ichida obyekt kelib qolsa u
 * ekranga `[object Object]` chizardi — ya'ni xom JSON'ni chiroyliroq
 * shaklda qaytarardi. Bu yerga faqat skalyar tushishi KERAK, lekin
 * "kerak" — dalil emas: obyekt kelsa uni oshkora bo'sh qoldiramiz va
 * chaqiruvchi uni `nested` sifatida ko'rsatadi.
 *
 * ⚠️ Satr `unwrapJavaToString` dan o'tadi — sabab o'sha funksiyada.
 * Bo'sh natija (`[]`, `{}`) ATAYLAB bo'sh qoladi: `AuditPage.DetailRow`
 * uni `common.dash` bilan chizadi, ya'ni "ro'yxat bo'sh" degani ekranda
 * chiziqcha bo'ladi, qavs emas.
 */
function scalarText(v: unknown): string {
  if (v === null || v === undefined) return ''
  if (typeof v === 'boolean') return v ? 'true' : 'false'
  if (typeof v === 'number' || typeof v === 'bigint') return v.toString()
  if (typeof v === 'string') {
    const text = unwrapJavaToString(v)
    return text.length > LIST_MAX ? `${text.slice(0, LIST_MAX)}…` : text
  }
  return ''
}

/**
 * `detail` JSONB obyektini ODAM O'QIYDIGAN qatorlarga ajratadi — BUG-044.
 *
 * <h2>Nima o'lchangan</h2>
 * 2026-08-16, jonli panel: audit qatorini yoyganda ekranda AYNAN
 * <code>{ "source": "PHONE" }</code> turardi — qavslar, qo'shtirnoqlar,
 * ikki nuqta. Tester izohi: «AUDIT LOGDA JSON BO'LMASLIGI KK, USER JSON
 * NIMALIGINI BILMEDI».
 *
 * <h2>⚠️ SHAKLLAR BAZADAN O'LCHANDI, TAXMIN QILINMADI</h2>
 * `platform.audit_log.detail` da uchta shakl uchraydi (o'lchandi
 * 2026-08-16, 8 mingdan ortiq qator):
 * <ul>
 *   <li>tekis juftliklar — <code>{"login":"...","state":"ACTIVE"}</code>;</li>
 *   <li>o'zgarish — <code>{"locale":{"before":"ru","after":"en"}}</code>
 *       (TENANT_SETTINGS_UPDATE) va yuqori darajadagi
 *       <code>{"from":"SUSPENDED","to":"ACTIVE"}</code> jufti
 *       (AGENT_STATE);</li>
 *   <li>ichma-ich — <code>permissions: [...]</code> (26 element),
 *       <code>findings: [{...}]</code> (LEDGER_RECONCILE, 96 element).</li>
 * </ul>
 *
 * ⚠️ Ichma-ich tuzilma YOYILMAYDI: LEDGER_RECONCILE ning
 * `informational` ro'yxati 96 ta obyekt va uni qatorma-qator chizish
 * jadvalni ishlatib bo'lmas holga keltirardi. O'rniga SONI ko'rsatiladi
 * va to'lig'i texnik blokda qoladi.
 *
 * ⚠️ Kalit tarjimasi TOPILMASA kalitning O'ZI qoladi (`nasname`,
 * `poolId`) — bu ham qavsli JSON'dan tushunarliroq, va yangi maydon
 * qo'shilganda ekran BO'SH qolmaydi.
 */
export function toDetailFields(raw: unknown): AuditDetailField[] {
  if (!isPlainObject(raw)) return []

  const out: AuditDetailField[] = []
  const hasFromTo = 'from' in raw && 'to' in raw

  // Yuqori darajadagi `from`/`to` jufti — BITTA o'zgarish qatori
  if (hasFromTo) {
    out.push({
      key: 'change',
      before: scalarText(raw['from']),
      value: scalarText(raw['to']),
      nested: false,
    })
  }

  for (const [key, value] of Object.entries(raw)) {
    if (hasFromTo && (key === 'from' || key === 'to')) continue

    if (Array.isArray(value)) {
      const scalars = value.filter((v) => !isPlainObject(v) && !Array.isArray(v))
      // Obyektlar massivi — faqat soni; skalyar massiv — ro'yxatning o'zi
      if (scalars.length === value.length) {
        const joined = scalars.map(scalarText).join(', ')
        out.push({
          key,
          before: null,
          value: joined.length > LIST_MAX ? `${joined.slice(0, LIST_MAX)}…` : joined,
          nested: false,
        })
      } else {
        out.push({ key, before: null, value: String(value.length), nested: true })
      }
      continue
    }

    if (isPlainObject(value)) {
      // `{before, after}` — bu O'ZGARISH, ichma-ich tuzilma emas
      if ('before' in value || 'after' in value) {
        out.push({
          key,
          before: scalarText(value['before']),
          value: scalarText(value['after']),
          nested: false,
        })
      } else {
        out.push({ key, before: null, value: String(Object.keys(value).length), nested: true })
      }
      continue
    }

    out.push({ key, before: null, value: scalarText(value), nested: false })
  }

  return out
}
